import { render, staticRenderFns } from "./UnlockContentPopUp.vue?vue&type=template&id=923a8828&"
import script from "./UnlockContentPopUp.vue?vue&type=script&lang=js&"
export * from "./UnlockContentPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports